import { createFileRoute } from "@tanstack/react-router";
import { ProcedurePage } from "@/features/experiments/procedure-page";
import { uploadSearch, type UploadSearch } from "@/lib/upload-route";

export const Route = createFileRoute("/procedures/$id")({
  validateSearch: (raw: Record<string, unknown>): UploadSearch & { view?: "log" } => ({
    ...uploadSearch(raw),
    view: raw.view === "log" ? ("log" as const) : undefined,
  }),
  component: Page,
});
function Page() {
  const { id } = Route.useParams();
  const { view } = Route.useSearch();
  return <ProcedurePage id={id} showLog={view === "log"} />;
}
